export const getParametroAsBoolean = (parametros, parametro) => {
  return parametros?.find(p => p?.parametro === parametro)?.valor === 'S';
};

export const getParametroAsInteger = (parametros, parametro) => {
  return parseInt(parametros.find(p => p?.parametro === parametro)?.valor)
}